"use client";
import Script from "next/script";

import { useConfig } from "@jti/ui/providers/useConfig";

export const GoogleRecaptcha = () => {
  const config = useConfig();
  const {
    "X-RECAPTCHA-ID": recaptchaId,
    reCaptchaEnabled,
    brandingInformationEnabled,
  } = config;

  const recaptchaHiddenCss = `
    .grecaptcha-badge {
      visibility: hidden;
    }
  `;

  return (
    <>
      {recaptchaId && reCaptchaEnabled && (
        // This component is actually rendered under the layout
        // but nested as it needs data from ConfigurationProvider
        // so the warning can be ignored
        // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
        <Script
          src={`https://www.google.com/recaptcha/api.js?render=${recaptchaId}&badge=bottomleft`}
          strategy="beforeInteractive"
        />
      )}
      {recaptchaId && reCaptchaEnabled && brandingInformationEnabled && (
        <style>{recaptchaHiddenCss}</style>
      )}
    </>
  );
};
